import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormContainer from '../../components/ui/FormContainer';
import Button from '../../components/ui/Button';
import { ArrowLeft } from 'lucide-react';
import { saveProgress, completeOnboarding } from '../../utils/onboardingApi';

const CalendarBooking = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [iframeUrl, setIframeUrl] = useState('');

  // Record that the user reached the calendar-booking step
  useEffect(() => {
    saveProgress('calendar-booking', { visitedAt: new Date().toISOString() })
      .catch(err => console.error('Failed to save calendar-booking step:', err));
  }, []);

  useEffect(() => {
    const baseUrl = 'https://links.tryraise.ai/widget/booking/QXf4eZPbLz9qdP2qZFrB';
    const dealFormData = localStorage.getItem('dealFormData');

    // Get query parameters from the main URL
    const urlParams = new URLSearchParams();

    urlParams.append('utm_source', 'onboarding');
    urlParams.append('source', 'onboarding');
    // Copy all query parameters from the main URL
    searchParams.forEach((value, key) => {
      urlParams.append(key, value);
    });

    // Add dealFormData if available
    if (dealFormData) {
      try {
        const parsedData = JSON.parse(dealFormData);
        const flattenedData = {};
        Object.entries(parsedData).forEach(([key, value]) => {
          if (value && typeof value === 'object' && !Array.isArray(value)) {
            Object.entries(value).forEach(([nestedKey, nestedValue]) => {
              flattenedData[`${key}_${nestedKey}`] = nestedValue;
            });
          } else {
            flattenedData[key] = value;
          }
        });
        const formattedData = Object.entries(flattenedData)
          .map(([key, value]) => `${key}=${value}`)
          .join('\n');
        urlParams.append('deal_input', formattedData);
      } catch (error) {
        console.error('Failed to get dealFormData:', error);
      }
    }

    // Build final URL with all parameters
    const finalUrl = urlParams.toString()
      ? `${baseUrl}?${urlParams.toString()}`
      : baseUrl;
    setIframeUrl(finalUrl);
  }, [searchParams]);

  const handleBack = () => {
    navigate('/investor-relations-contact');
  };

  return (
    <FormContainer maxWidth="max-w-4xl">
      <div className="space-y-6">
        {/* Header */}
        <div className="space-y-4">
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back</span>
          </button>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Schedule Your Onboarding Call
            </h1>
            <p className="text-gray-600">
              Schedule a time to review your setup and get started with your campaign.
            </p>
          </div>
        </div>

        {/* Calendar iframe */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {iframeUrl ? (
            <iframe
              src={iframeUrl}
              style={{
                width: '100%',
                height: '800px',
                border: 'none',
                borderRadius: '8px'
              }}
              title="Calendar Booking"
              allow="payment"
            />
          ) : (
            <div className="flex items-center justify-center h-[800px]">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
          )}
        </div>

        {/* Complete Button */}
        <div className="pt-6">
          <Button
            onClick={async () => {
              try {
                await saveProgress('complete', { completedAt: new Date().toISOString() });
                await completeOnboarding();
              } catch (err) {
                console.error('Failed to mark onboarding complete:', err);
              }
              navigate('/onboarding-complete');
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
            size="lg"
          >
            Complete
          </Button>
        </div>
      </div>
    </FormContainer>
  );
};

export default CalendarBooking;
